import { render, staticRenderFns } from "./feeTable.vue?vue&type=template&id=ab350080&scoped=true&"
import script from "./feeTable.vue?vue&type=script&lang=js&"
export * from "./feeTable.vue?vue&type=script&lang=js&"
import style0 from "./feeTable.vue?vue&type=style&index=0&id=ab350080&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab350080",
  null
  
)

export default component.exports